import React from "react";
import { Tick, WixInstallImg } from "../../../../../assets";
import { MdMenuBook } from "react-icons/md";
import { WixFeatureObj } from "../constants";

const IntegrationBenefits = () => {
  return (
    <section className="max-w-xl">
      <img
        src={WixInstallImg}
        alt="Wix Installation"
        className="my-4"
      />
      <p className="text-sm text-gray-500 my-2.5">
        Connect Wix with CausalFunnel to streamline your Customer Support.
        Make it easier and faster to manage your crm details.
      </p>
      <div>
        <h3 className="text-xl font-semibold py-3 border-bottom my-3">
          Integration benefits
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 my-3">
          {WixFeatureObj.map((item, index) => (
            <FeatureItem {...item} key={index} />
          ))}
        </div>
      </div>
      <a
        href="https://www.causalfunnel.com/blog"
        target="_blank"
        rel="noreferrer noopener"
        className="text-indigo-600 hover:underline flex items-center gap-1.5"
      >
        <MdMenuBook className="text-2xl" />
        <p>How to install Wix?</p>
      </a>
    </section>
  );
};

export default IntegrationBenefits;

const FeatureItem = ({ title, desc }) => {
  return (
    <div className="flex gap-2">
      <div className="">
        <Tick className=" text-green-600" />
      </div>
      <div>
        <h3 className="font-bold text-[14px]">{title}</h3>
        <p className="text-gray-500 text-[14px]">{desc}</p>
      </div>
    </div>
  );
};

const MailChimpFeatureObj = [
  {
    title: "Add subscribers from pre-chat survey",
    desc: "Whenever a visitor enters their email and communication consent, the email will be added to your Mailchimp list.",
  },
  {
    title: "Add subscribers from chatbots",
    desc: "Use 'Subscribe for Mailing' node to collect visitor's email and send it to Mailchimp.",
  },
  {
    title: "Add subscribers via manual status update",
    desc: "Change a user's subscriber status in the visitor's details tab or contact list to pass the email to Mailchimp.",
  },
];
